import * as login from '../../constants/login'
import Axios from 'axios'

const fetchOperatorSuccess = ({ operator }) => {
    return {
        type: login.LOGIN_FETCH_OPERATOR_INFO,
        payload: { operator: operator }
    }
}

export const fetchOperator = login_operatora => async dispatch => {
    try {
        const response = await Axios.get(`/api/login/operator/${login_operatora}`);
        dispatch(fetchOperatorSuccess({ operator: response.data }))
    } catch (error) {
        console.log(error)
    }
}

export const fetchSessionObj = () => async dispatch => {
    try {
        const response = await Axios.get('/api/login/isAuthenticated')
        dispatch(setLoginSessionObj({ session: response.data }))
    } catch (error) {
        console.log(error)
    }
}

export const setLoginSessionObj = ({ session }) => {
    return {
        type: login.LOGIN_SET_SESSION_OBJ,
        payload: { session }
    }
}